import { useMemo, Fragment } from 'react';
import { ChevronIcon } from '@ui/kit/icons';
import { sequenceTileInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { SequenceInput } from '../input.content.js';
import { orderInputs } from '../util.order-inputs.js';
import { container, chevron } from './container.print.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function VerticalPrintContainer(props) {
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sequenceTileInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  return /*#__PURE__*/jsx("div", {
    className: container,
    children: userOrderedInputs.map(input => /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(SequenceInput, {
        node: input,
        taskEntryKey: props.taskEntryKey
      }), /*#__PURE__*/jsx(ChevronIcon, {
        className: chevron,
        height: 8,
        strokeWidth: 3
      })]
    }, input.id))
  });
}

export { VerticalPrintContainer };
//# sourceMappingURL=container.print.js.map
